import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { EnvironmentService } from 'src/app/shared/common/environment/environment.service';
import { StyleSymbol, SymbologyOverride, SymbolOverrideDTO, SymbolShapeDefinition } from './style-symbology';

@Injectable({
    providedIn: 'root'
})
export class StyleSymbologyService {
    constructor(private http: HttpClient, private env: EnvironmentService) {}

    public async getAvailableSymbolDefinitions(): Promise<SymbolShapeDefinition[]> {
        const path = this.env.apiUrl + '/symbols/definitions';

        return lastValueFrom(this.http.get<{ items: SymbolShapeDefinition[] }>(path)).then(response => {
            return response.items;
        });
    }

    public async createSymbol(projectId: string, symbol: StyleSymbol): Promise<StyleSymbol> {
        const path = this.env.apiUrl + '/projects/' + projectId + '/symbols';

        return lastValueFrom(this.http.post<StyleSymbol>(path, symbol));
    }

    public async updateSymbol(projectId: string, symbol: StyleSymbol): Promise<StyleSymbol> {
        const path = this.env.apiUrl + '/projects/' + projectId + '/symbols/' + symbol.id;

        return lastValueFrom(this.http.put<StyleSymbol>(path, symbol));
    }

    public async deleteSymbol(projectId: string, symbol: StyleSymbol): Promise<boolean> {
        const path = this.env.apiUrl + '/projects/' + projectId + '/symbols/' + symbol.id;

        return lastValueFrom(this.http.delete<boolean>(path));
    }

    // Symbology overrides

    public async getStyleOverrideById(projectId: string, overrideId: string): Promise<SymbolOverrideDTO[]> {
        const path = this.env.apiUrl + '/projects/' + projectId + '/styleoverrides/' + overrideId;

        return lastValueFrom(this.http.get<SymbolOverrideDTO[]>(path)).then(response => (response as any).items);
    }

    public async createStyleOverrides(
        projectId: string,
        styleId: string,
        overrides: SymbologyOverride[]
    ): Promise<SymbolOverrideDTO[]> {
        const path = this.env.apiUrl + '/projects/' + projectId + '/styles/' + styleId + '/styleoverrides/_bulk/_post';

        return lastValueFrom(this.http.post<SymbolOverrideDTO[]>(path, overrides)).then(
            response => (response as any).items
        );
    }

    public async removeStyleOverride(projectId: string, overrideId: string): Promise<SymbolOverrideDTO> {
        const path = this.env.apiUrl + '/projects/' + projectId + '/styleoverrides/' + overrideId;

        return lastValueFrom(this.http.delete<SymbolOverrideDTO>(path));
    }

    public async updateStyleOverrides(
        projectId: string,
        styleId: string,
        overrides: SymbologyOverride[]
    ): Promise<SymbolOverrideDTO[]> {
        const path = this.env.apiUrl + '/projects/' + projectId + '/styles/' + styleId + '/styleoverrides/_bulk/_put';

        return lastValueFrom(this.http.put<SymbolOverrideDTO[]>(path, overrides)).then(
            response => (response as any).items
        );
    }
}
